module.exports = __webpack_public_path__ + "media/images/projects/8-dashboard-7bf7a68e4b63e3c3159ab7f629a482a2.jpg";